module.exports = __webpack_public_path__ + "images/4c8ed80ca66fb7461d681f23a64502a4.svg";